define('meeting-modal/meeting-modal',['require','api-access','dialog-helper/responsive','tealium-utils','mixpanel-helper','api-access','api-access','meeting-modal/time-selector/time-selector','meeting-modal/tab-options/audio-tab','meeting-modal/tab-options/coorganizer-tab','meeting-modal/tab-options/startup-tab','meetings/lib/share-meeting/share-meeting','knockout','durandal/app','plugins/dialog','lodash','i18next','knockout-bind-html','web-urls'],function (require) {
    var meetingsApi = require('api-access').meetings;
    var responsiveDialog = require('dialog-helper/responsive');
    var tealiumUtils = require('tealium-utils');
    var mixpanelHelper = require('mixpanel-helper');
    var userApi = require('api-access').user;
    var gotomeet = require('api-access').gotomeet;

    var TimeSelector = require('meeting-modal/time-selector/time-selector');
    var AudioTab = require('meeting-modal/tab-options/audio-tab');
    var CoorganizerTab = require('meeting-modal/tab-options/coorganizer-tab');
    var StartupTab = require('meeting-modal/tab-options/startup-tab');
    var ShareMeeting = require('meetings/lib/share-meeting/share-meeting');

    var ko = require('knockout');
    var app = require('durandal/app');
    var dialog = require('plugins/dialog');
    var _ = require('lodash');
    var i18n = require('i18next');

    require('knockout-bind-html');

    var gotoMeetMeUrl = require('web-urls').get('gotoMeetMeUrl');

    /**
     * Modal used to schedule or edit meetings.
     *
     * Usage:
     * MeetingModal.show(); or MeetingModal.show(12345678);
     *
     * If a meetingId is supplied, the module will assume edit behavior.
     * For schedule behavior, do not supply a meetingId.
     */
    var MeetingModal = function (meetingId, roomId) {
        var self = this;

        // Returns a more readable meeting ID with dashes, displays in edit mode.
        self.formattedMeetingId = ko.observable(
            String(meetingId || '').replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3')
        );

        self.roomId = ko.observable(roomId);
        self.meetingName = ko.observable().extend({
            restrictedRegex: true
        });

        /**
         * Compose different portions of the modal as modules.
         */
        self.timeSelector = ko.observable(new TimeSelector(meetingId));
        self.audioTab = ko.observable(new AudioTab(meetingId));
        self.startupTab = ko.observable(new StartupTab(meetingId));
        self.coorganizerTab = ko.observable(new CoorganizerTab(meetingId));
        self.roomsFlag = ko.observable();
        self.countrySelector = self.audioTab().countrySelector;

        // Functionality for these button actions are in a separate module.
        self.saveCountrySelector = self.audioTab().saveCountrySelector;
        self.cancelCountrySelector = self.audioTab().cancelCountrySelector;

        // Use to check deeply if any option module is invalid.
        self.validation = ko.validatedObservable({
            timeSelector: self.timeSelector().validation,
            audioTab: self.audioTab().validation
        });

        // Settings loaded - To be initialized on composition complete.
        self.initialSettings = {};

        // Populate audio options via API response (if roomsEnabled)
        self.defaultAudioOptions = {};

        /**
         * Each module has a buildOption() function which will return an object formatted in a way the API expects.
         * Combine all those options to form the final object to be consumed by the API.
         */
        self.combineOptions = function (meetingName, meetingIdResponse, roomIdResponse) {
            var combinedOptions = {};

            /*
             * If the meeting name is blank, fill it in before sending the request.
             * TODO: Is this ideal? Perhaps this should be handled on the backend or on the meeting-list instead.
             */
            if (meetingName.length === 0) {
                combinedOptions.subject = i18n.t('meeting.schedule.title.default.text');
            } else {
                combinedOptions.subject = meetingName;
            }

            combinedOptions = _.merge(combinedOptions, self.timeSelector().buildOptions());

            // If rooms flag is disabled (OR) a Normal meeting with no room id is edited, then build Audio options.
            if (!self.roomsFlag() || (meetingIdResponse && !roomIdResponse)) {
                combinedOptions = _.merge(combinedOptions, self.audioTab().buildOptions());
            } else {
                // If a Room
                // Get the organizer's default audio settings
                combinedOptions = _.merge(combinedOptions, {audio: self.defaultAudioOptions});
            }
            combinedOptions = _.merge(combinedOptions, self.coorganizerTab().buildOptions());
            combinedOptions = _.merge(combinedOptions, self.startupTab().buildOptions());

            return combinedOptions;
        };

        self.shareMeeting = function (mtngId) {
            var shareModal = new ShareMeeting(mtngId || meetingId);
            shareModal.show();
        };

        self.save = function () {
            var combinedOptions = self.combineOptions(self.meetingName(), meetingId, self.roomId());
            if (meetingId) {
                // Check if any meeting settings changed.
                // If not, do not make any API calls - Close the modal and return instead.
                if (_.isEqual(combinedOptions, self.initialSettings)) {
                    self.close();
                    return;
                } else if (_.isEqual(combinedOptions.audio, self.initialSettings.audio)) {
                    delete combinedOptions.audio;
                }

                meetingsApi.updateSettings(meetingId, combinedOptions)
                    .then(function () {
                        var mixPanelData = {
                            ID: meetingId,
                            Type: combinedOptions.meetingType
                        };
                        window.mixpanel.track('Edit a Meeting', mixPanelData);

                        app.trigger('get:meetings');
                        self.close();
                        self.shareMeeting(meetingId);
                    });

                /**
                 * TODO: Removal of the coorganizer keys requires a separate distinct API call.
                 * Sending an empty coorganizer keys array will not work. This behavior is flawed.
                 * When that gets fixed, remove this section.
                 */
                if (self.coorganizerTab().isCoorganizerEnabled() &&
                        combinedOptions.coorganizerKeys &&
                        combinedOptions.coorganizerKeys.length === 0) {
                    meetingsApi.removeAllCoorganizers(meetingId);
                }
            } else {
                meetingsApi.create(combinedOptions)
                    .then(function (meeting) {
                        var mixPanelData = {
                            ID: meeting.meetingId,
                            Type: meeting.meetingType,
                            'Password Required': meeting.passwordRequired,
                            'Audio Mode': mixpanelHelper.tidyAudioString(
                                combinedOptions.audio.audioType,
                                combinedOptions.audio.tollCountries,
                                combinedOptions.audio.tollFreeCountries),
                            'Toll Countries': 'None',
                            'Toll Free Countries': 'None'
                        };
                        if (meeting.audio.tollCountries) {
                            mixPanelData['Toll Countries'] = combinedOptions.audio.tollCountries;
                        }
                        if (meeting.audio.tollFreeCountries) {
                            mixPanelData['Toll Free Countries'] = combinedOptions.audio.tollFreeCountries;
                        }
                        window.mixpanel.track('Schedule a Meeting', mixPanelData);
                        app.trigger('get:meetings');
                        self.close();

                        if (self.roomsFlag()) {
                            gotomeet.getByUserKey().then(function (res) {
                                gotomeet.createMeetingRoom(res.profileId, meeting.meetingId).done(function (data) {
                                    window.location.href = gotoMeetMeUrl + '/' + data.profileId + '/' + data.roomId;
                                });
                            });
                        } else {
                            self.shareMeeting(meeting.meetingId);
                        }
                    });
            }
        };

        self.close = function () {
            dialog.close(self);
        };

        self.activate = function () {
            // For an existing meeting, fetch the existing settings, otherwise use schedule defaults.
            if (meetingId) {
                meetingsApi.byIdFormatted(meetingId)
                    .then(function (meeting) {
                        self.meetingName(meeting.subject);
                    });
            }

            // Get the roomsEnabled boolean value to know if the organizer has opted in for rooms or not.
            return userApi.settings().then(function (settings) {
                // check settings API to see if it has `roomsEnabled` property
                if (settings.hasOwnProperty('roomsEnabled')) {
                    // Set roomsEnabled flag.
                    // downgrade users will get roomsProvisioned set to false
                    self.roomsFlag(settings.roomsProvisioned && settings.roomsEnabled);

                    if (settings.audio.defaultModes.indexOf('PRIVATE') > -1) {
                        self.defaultAudioOptions.audioType = 'private';
                        self.defaultAudioOptions.privateMessage = settings.audio.defaultModeratorPrivateMessage;
                    } else {
                        // Set Audio options
                        var isSelectedVoip = settings.audio.defaultModes.indexOf('VOIP') > -1;
                        var isSelectedToll = settings.audio.defaultModes.indexOf('TOLL') > -1;
                        var isSelectedTollFree = settings.audio.defaultModes.indexOf('TOLLFREE') > -1;

                        if (isSelectedVoip && (isSelectedTollFree || isSelectedToll)) {
                            self.defaultAudioOptions.audioType = 'voipAndPstn';
                        } else if (isSelectedVoip) {
                            self.defaultAudioOptions.audioType = 'voip';
                        } else {
                            self.defaultAudioOptions.audioType = 'pstn';
                        }

                        if (isSelectedToll) {
                            self.defaultAudioOptions.tollCountries = settings.audio.defaultTollCountries;
                        }

                        if (isSelectedTollFree) {
                            self.defaultAudioOptions.tollFreeCountries = settings.audio.defaultTollFreeCountries;
                        }
                    }
                } else {
                    self.roomsFlag(false);
                }
            });
        };

        self.compositionComplete = function (child) {
            responsiveDialog(self, child);

            $('.meeting-modal a[data-toggle="tab"]').on('shown.bs.tab', function () {
                var href = this.href;
                var page = meetingId ? 'editmeeting' : 'schedulemeeting';

                if (href.indexOf('audio') > -1) {
                    tealiumUtils.sendTealiumEvent(page, 'm_audio.html');
                }

                if (href.indexOf('coorg') > -1) {
                    tealiumUtils.sendTealiumEvent(page, 'm_coorg.html');
                }

                if (href.indexOf('startup') > -1) {
                    tealiumUtils.sendTealiumEvent(page, 'm_startup.html');
                }
                self.centerModal();
            });

            // Show the audio tab by default
            $('.nav-tabs a[href="#audio"]').tab('show');

            if (meetingId) {
                // Initialize loaded settings.
                self.initialSettings = self.combineOptions(self.meetingName(), meetingId, self.roomId());
            }
        };

        self.centerModal = function () {
            $(window).trigger('resize');
        };
    };

    MeetingModal.show = function (meetingId, roomId) {
        return dialog.show(new MeetingModal(meetingId, roomId));
    };

    return MeetingModal;
});

